<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item v-show="true" label="楼层ID">
                  <el-input  v-model="queryForm.floorId"></el-input>
              </el-form-item>
              <el-form-item label="品牌ID">
                  <el-input  v-model="queryForm.brandId"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopFloorBrandList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopFloorBrand"
        >新建</el-button>
<!--        <el-button-->
<!--          type="warning"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-edit"-->
<!--          :disabled="multipleSelection.length != 1"-->
<!--          @click="editShopFloorBrand(null)"-->
<!--        >修改</el-button>-->
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteShopFloorBrand(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopFloorBrandList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopFloorBrandList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopFloorBrandList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorId"
        label="楼层ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="brandId"
        label="品牌ID"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkShopFloorBrand(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopFloorBrand(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopFloorBrand(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopFloorBrandStates[shopFloorBrandState]"
      :visible.sync="showDialog"
      width="400px"
      :modal="false"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopFloorBrand"
          ref="shopFloorBrandForm"
          :rules="rules"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="楼层ID"
            prop="floorId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloorBrand.floorId"-->
<!--              disabled-->
<!--            ></el-input>-->
              <el-select
                  style="width: 283px"
                  v-model="shopFloorBrand.floorId"
                  placeholder="请选择所属楼层"
                  disabled
                  clearable
                  size="small"
              >
                  <el-option v-for="(item,index) in floorIdList " :label="item.floorName" :value="item.id" :key="index"> </el-option>
              </el-select>
          </el-form-item>
          <el-form-item
            label="品牌ID"
            prop="brandId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloorBrand.brandId"-->
<!--              :disabled="shopFloorBrandState == 'check'"-->
<!--            ></el-input>-->
              <div style="display: flex;">
                  <GridSelectLi
                      ref="add1"
                      style="width: 220px;"
                      title="选择品牌"
                      labelName="brandName"
                      labelValue="id"
                      :disabled="shopFloorBrandState == 'check'"
                      :did="did"
                      :value="shopFloorBrand.brandId"
                      :limit="99"
                      size="small"
                      placeholder="请选择商品"
                      @getValue="getValuebrandId"
                      :columns="BRAND_code"
                      :searchs="BRAND_search"
                      dataListUrl='shop/productbrand/findList'
                      entityBeanName='shopBrand'
                      queryEntityUrl='shop/productbrand/get'
                  >
                  </GridSelectLi>
                  <el-button style="height: 30px;margin: 0 4px;width: 55px" type="primary" @click="add1">添加</el-button>
              </div>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopFloorBrandState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectLi from '@/components/gridselect/gidselect.vue';
import GridSelect from '@/components/gridselect/brand.vue';
import { BRAND, BRAND_SEARCH } from '@/utils/constant';

export default {
    components: {
        GridSelect,
        GridSelectLi,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopFloorBrandList();
                    this.getShopFloorBrandList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopFloorBrandList();
                    this.getShopFloorBrandList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     floorId: '', //楼层ID
                     brandId: '', //品牌ID
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopFloorBrandState: 'add',
                shopFloorBrandStates: {
                    add: '新建shop_floor_brand',
                    check: '查看shop_floor_brand',
                    edit: '修改shop_floor_brand'
                },
                did: '',
                multipleSelection: [],
                shopFloorBrandList: [],
                shopFloorBrand: {
                    id: '', //ID
                    floorId: '', //楼层ID
                    brandId: '', //品牌ID
                },
                btnLoading: false,
                floorIdList: [],
                rules: {
                    floorId: [{ required: true, message: '楼层ID不能为空', trigger: 'blur' }],
                    brandId: [{ required: true, message: '品牌ID不能为空', trigger: 'blur' }],
                },
                BRAND_code: BRAND,
                BRAND_search: BRAND_SEARCH,
            };
        },
        created() {
            // this.getShopFloorBrandList();
        },
        methods: {
            updateIds(id) {
                this.queryForm.floorId = id;
                this.getShopFloorBrandList();
                this.getFloorIdList()
            },
            add1(){
                this.$refs.add1.showSelectDialog();
                console.log(this.$refs.add1)
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            // 获取楼层
            getFloorIdList(){
                get(`/shop/floor/findAll`,{}).then((res) => {
                    if (res.success) {
                        this.floorIdList = res.list
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            resetShopFloorBrandList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopFloorBrandList = [];
            },
            resetDialog() {
                this.shopFloorBrandState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      floorId: this.queryForm.floorId, //楼层ID
                      brandId: '', //品牌ID
                };
                this.getShopFloorBrandList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopFloorBrand = {
                      id: '', //ID
                      floorId: '', //楼层ID
                      brandId: '', //品牌ID
                };
            },
            getValuebrandId(val){
                this.shopFloorBrand.brandId = val
            },
            submitForm() {
                if (this.shopFloorBrandState == 'add') {
                    this.$refs.shopFloorBrandForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/floorbrand/add`,{ ...this.shopFloorBrand }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopFloorBrandList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopFloorBrandState == 'edit') {
                    this.$refs.shopFloorBrandForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopFloorBrand.updateTime
                            delete this.shopFloorBrand.brand
                            post(`/shop/floorbrand/edit`,{ ...this.shopFloorBrand }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopFloorBrandList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopFloorBrand() {
                this.showDialog = true;
                this.shopFloorBrandState = 'add';
                this.shopFloorBrand.floorId = this.queryForm.floorId
            },
            checkShopFloorBrand(shopFloorBrandId) {
                console.log(shopFloorBrandId);
                this.currentShopFloorBrandId = shopFloorBrandId;

                this.getShopFloorBrandById();
                this.showDialog = true;
                this.shopFloorBrandState = 'check';
            },
            editShopFloorBrand(shopFloorBrandId) {
                console.log('shopFloorBrand', shopFloorBrandId);
                if (shopFloorBrandId) {
                    this.currentShopFloorBrandId = shopFloorBrandId;
                    this.getShopFloorBrandById();
                } else {
                    this.shopFloorBrand = { ...this.shopFloorBrand, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopFloorBrandState = 'edit';
            },
            deleteShopFloorBrand(shopFloorBrandId) {
                let ids = '';
                if (shopFloorBrandId) {
                    ids = shopFloorBrandId;
                } else {
                    ids = this.multipleSelection.map((shopFloorBrand) => shopFloorBrand.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/floorbrand/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopFloorBrandList();
                                this.getShopFloorBrandList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshShopFloorBrandList() {
                this.resetShopFloorBrandList();
                this.getShopFloorBrandList();
            },
            getShopFloorBrandList(query = {}) {
                this.loading = true;
                get(`/shop/floorbrand/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopFloorBrandList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopFloorBrandById() {
                get(`/shop/floorbrand/get`,{ id: this.currentShopFloorBrandId }).then((res) =>{
                    if(res.success){
                      this.shopFloorBrand = { ...this.shopFloorBrand, ...res.shopFloorBrand };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopFloorBrandList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/floorbrand/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/floorbrand/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/floorbrand/importData`,formData);
              this.refreshShopFloorBrandList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopFloorBrandList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopFloorBrandList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>